interface AutoNavigationPageLike {
  id: string;
}

interface ResolveAutoNavigationTargetPageIndexParams {
  visiblePages: AutoNavigationPageLike[];
  firstRequiredIncompletePageIndex: number;
  firstEmptyEditablePageIndex: number;
  hasHydratedSignerContext: boolean;
  currentSignerCompleted: boolean;
}

export function findLastNonDocumentUploadPageIndex(
  visiblePages: AutoNavigationPageLike[],
  documentUploadPageIndex: number
): number {
  for (let pageIndex = visiblePages.length - 1; pageIndex >= 0; pageIndex--) {
    if (pageIndex !== documentUploadPageIndex) {
      return pageIndex;
    }
  }

  return -1;
}

export function resolveAutoNavigationTargetPageIndex({
  visiblePages,
  firstRequiredIncompletePageIndex,
  firstEmptyEditablePageIndex,
  hasHydratedSignerContext,
  currentSignerCompleted,
}: ResolveAutoNavigationTargetPageIndexParams): number {
  const documentUploadPageIndex = visiblePages.findIndex((page) => page.id === 'document-upload');
  const hasDocumentUploadPage = documentUploadPageIndex >= 0;
  const shouldSkipDocumentUploadForIncompleteSigner =
    hasDocumentUploadPage && hasHydratedSignerContext && !currentSignerCompleted;
  const lastNonDocumentUploadPageIndex = hasDocumentUploadPage
    ? findLastNonDocumentUploadPageIndex(visiblePages, documentUploadPageIndex)
    : visiblePages.length - 1;

  let targetPageIndex = firstRequiredIncompletePageIndex;
  if (targetPageIndex < 0) {
    targetPageIndex = firstEmptyEditablePageIndex;
  }

  if (targetPageIndex < 0) {
    return shouldSkipDocumentUploadForIncompleteSigner && lastNonDocumentUploadPageIndex >= 0
      ? lastNonDocumentUploadPageIndex
      : visiblePages.length - 1;
  }

  if (
    shouldSkipDocumentUploadForIncompleteSigner &&
    targetPageIndex === documentUploadPageIndex &&
    lastNonDocumentUploadPageIndex >= 0
  ) {
    return lastNonDocumentUploadPageIndex;
  }

  return targetPageIndex;
}
